export function getSafeReturnTo(returnTo: string | null | undefined, fallback: string): string {
  if (!returnTo || typeof returnTo !== 'string') {
    return fallback;
  }

  if (!returnTo.startsWith('/') || returnTo.startsWith('//')) {
    return fallback;
  }

  return returnTo;
}
